import { render, staticRenderFns } from "./_payableStatements.vue?vue&type=template&id=204d6dff&scoped=true&"
import script from "./_payableStatements.vue?vue&type=script&lang=js&"
export * from "./_payableStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204d6dff",
  null
  
)

export default component.exports